import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

import { EResult } from '../../repositories/files/entities/Models/AddFileResponse';
import { fetchAdd, TAddResponse } from '../../repositories/files/v1/add';
import { ICancellationToken } from '../../utils/cancelationToken';

interface IAddFilesContext {
  httpApi: IHttpApi;
  logger: ILogger;
}

interface IAddFilesRequest {
  file?: File;
  cancellationToken: ICancellationToken;
}

export { EResult as EAddFilesResult };

export async function addFiles(context: IAddFilesContext, { file, cancellationToken }: IAddFilesRequest) {
  const { httpApi, logger } = context;

  try {
    const response: TAddResponse = await fetchAdd({
      httpApi,
      parameters: {
        file,
      },
      config: {
        cancellationToken,
      },
    });

    return { response: response.response, responseStatusCode: response.statusCode };
  } catch (error) {
    logger.warning(error, {
      domain: 'frontend-chats.api.addFiles',
      message: 'Не удалось загрузить файл на сервер',
    });

    throw error;
  }
}
